import React from 'react';
import { CHECKOUT_URL, PRODUCT_IMAGE, PRODUCT_NAME } from './constants';
interface ProductArtworkProps {
  className?: string;
}
export function ProductArtwork({
  className = ''
}: ProductArtworkProps) {
  return <a href={CHECKOUT_URL} aria-label={`Purchase ${PRODUCT_NAME}`} className="block focus:outline-none focus:ring-4 focus:ring-electric/35" data-id="element-155">
      <img src={PRODUCT_IMAGE} alt="STRENGTH READY™ Complete 6-in-1 Planning System for Strength & Conditioning Coaches" className={`h-auto w-full object-contain ${className}`} data-id="element-156" />
    </a>;
}